import { render, staticRenderFns } from "./FlexibleChart.vue?vue&type=template&id=6b1894b7&scoped=true"
import script from "./FlexibleChart.vue?vue&type=script&lang=js"
export * from "./FlexibleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1894b7",
  null
  
)

export default component.exports